/**
 * @generated SignedSource<<d4cac5481374906d8c03035c84a2e31e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AdminRejectAccountInput = {
  reason?: string | null;
  userId: string;
};
export type ApprovalsPageRejectMutation$variables = {
  input: AdminRejectAccountInput;
};
export type ApprovalsPageRejectMutation$data = {
  readonly AdminRejectAccount: {
    readonly error: string | null;
    readonly success: boolean;
  };
};
export type ApprovalsPageRejectMutation = {
  response: ApprovalsPageRejectMutation$data;
  variables: ApprovalsPageRejectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminRejectAccountPayload",
    "kind": "LinkedField",
    "name": "AdminRejectAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ApprovalsPageRejectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApprovalsPageRejectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0f89c78dd78258167be18c45614e035a",
    "id": null,
    "metadata": {},
    "name": "ApprovalsPageRejectMutation",
    "operationKind": "mutation",
    "text": "mutation ApprovalsPageRejectMutation(\n  $input: AdminRejectAccountInput!\n) {\n  AdminRejectAccount(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d0e590a031ba8ff012ceb1344aed6e8";

export default node;
